import { inject } from "@angular/core";
import {
  ActivatedRouteSnapshot,
  CanActivateFn,
  Router,
  RouterStateSnapshot,
  UrlTree,
} from "@angular/router";
import { PlatformService } from "../../services/platform.service";

/**
 * Blocks entry to a `/review` route when there is no active draft (`PATCH_FORM`
 * key in sessionStorage). Redirects the user to the platform-aware Services page
 * (`/paid` for the paid flow, `/` for EPAK).
 *
 * Prevents two classes of bug:
 * - Hard refresh of a `/review` URL after a successful submission cleared the
 *   draft (would otherwise re-render the review skeleton and tempt a duplicate
 *   submission).
 * - Cold-load / deep-link of `/review` without ever filling out the wizard.
 */
export const reviewDraftGuard: CanActivateFn = (
  _route: ActivatedRouteSnapshot,
  _state: RouterStateSnapshot,
): boolean | UrlTree => {
  const router = inject(Router);
  const platformService = inject(PlatformService);

  const hasDraft = !!sessionStorage.getItem("PATCH_FORM");
  if (hasDraft) {
    return true;
  }

  const target = platformService.brandName() === platformService.paidPlatform ? "/paid" : "/";
  return router.parseUrl(target);
};
